import React from 'react';
import PropTypes from 'prop-types';
import Icon from '@ifit/react-icons/dist/components/icon';
import CLOSE_LINE from '@ifit/react-icons/dist/icons/CLOSE_LINE';
import cx from 'classnames';
import './index.scss';

const CloseButton = ({ onClick, className }) => (
  <div
    className={cx('close', 'circle-button', className)}
    data-testid="Close"
    onClick={onClick}
  >
    <Icon icon={CLOSE_LINE} size={24} color="rgba(255, 255, 255, 0.54)" />
  </div>
);

CloseButton.propTypes = {
  onClick: PropTypes.func,
  className: PropTypes.string,
};

export default CloseButton;
